import React, { useLayoutEffect } from 'react'
import { NextPage } from 'next'
import styles from '@src/styles/test.module.scss'
import cardStyles from '@src/styles/card.module.scss'
import Head from 'next/head'
import userStyles from '@src/styles/style.module.scss'
import CardSection from '@src/components/CardSection'
import Card from '@src/components/Card'
import HomeBanner from '@src/components/HomeBanner'
import { CompanySection } from '@src/components/CompanySection'
import { CookiesModal } from '@src/pages/_app'
import useTranslation from '@src/hooks/translation'
import { MINIO_BUCKET_URL } from '@src/constants/constant'

const homeSectionEvents: Record<string, string> = {
  urun: 'web_product_section_view',
  entegrasyon: 'web_integration_section_view',
  partner: 'web_partner_section_view',
  sigorta: 'web_company_section_view',
}

const sendGtagEvent = (eventName: string) => {
  // @ts-ignore
  window.gtag('event', eventName)
}

const Home: NextPage = () => {
  const translator = useTranslation().home

  const cardInfos2 = [
    <Card
      imageSrc="card_img/animal_dog.png"
      title={translator.step2.card1.title}
      description={translator.step2.card1.text}
    />,
    <Card
      imageSrc="card_img/travel_insurance.png"
      title={translator.step2.card2.title}
      description={translator.step2.card2.text}
    />,
    <Card
      imageSrc="card_img/invoice_protection.png"
      title={translator.step2.card3.title}
      description={translator.step2.card3.text}
    />,
    <Card
      imageSrc="card_img/screen_breakage.png"
      title={translator.step2.card4.title}
      description={translator.step2.card4.text}
    />,
    <Card
      imageSrc="card_img/appliance_insurance.png"
      title={translator.step2.card5.title}
      description={translator.step2.card5.text}
    />,
    <Card
      imageSrc="card_img/emergency_health.png"
      title={translator.step2.card6.title}
      description={translator.step2.card6.text}
    />
  ]
  const cardInfosSecondary = [
    <Card
      imageSrc="card_img/earthquake_insurance.svg"
      title={translator.step2.card7.title}
      description={translator.step2.card7.text}
    />,
    <Card
      imageSrc="card_img/traffic_insurance.svg"
      title={translator.step2.card8.title}
      description={translator.step2.card8.text}
    />,
  ]
  const cardInfos3 = [
    <Card
      imageSrc="card_img/embedded_insurance.png"
      title={translator.step3.card1.title}
      description={translator.step3.card1.text}
    />,
    <Card
      imageSrc="card_img/affinity_projeleri.png"
      title={translator.step3.card2.title}
      description={translator.step3.card2.text}
    />,
    <Card
      imageSrc="card_img/lead_uretimi.png"
      title={translator.step3.card3.title}
      description={translator.step3.card3.text}
    />,
  ]

  /* const partners1 = [
     {
       title: 'Teknoloji',
       logo: 'company_logos/paycell.svg'
     },

     {
       title: 'Akaryakıt',
       logo: 'company_logos/tp.svg'
     },

     {
       title: 'Enerji',
       logo: 'company_logos/oldubil.svg'
     }
   ] */
  const partners = [
    {
      logo: 'company_logos/colendi.png',
    },
    {
      logo: 'company_logos/m-one.png',
    },
    {
      logo: 'company_logos/migros.png',
    },
    {
      logo: 'company_logos/paket-taxi.png',
    },
    {
      logo: 'company_logos/money.png',
    },
  ]

  const insuranceCompanies = [
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/allianz.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/anadolu.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/ankara.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/axa.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/bupa-acibadem.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/doga.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/eureko.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/hdi.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/hepiyi.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/koru.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/mapfre.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/neova.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/ray.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/turkiye.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/unico.png`,
    },
    {
      logo: `${MINIO_BUCKET_URL}/colendi-insurance-landing/providers/zurich.png`,
    },
  ]

  useLayoutEffect(() => {
    setTimeout(() => {
      const refs = window.location.href.split('?p=')
      if (refs.length <= 1) {
        sendGtagEvent('web_home_page_view')
        return
      }

      const isProduct = refs[1] === 'urun2'
      const targetId = isProduct ? 'urun' : refs[1]
      const target = document.getElementById(targetId)

      if (!target) {
        return
      }

      const scrollOffset = targetId === 'ekibe-katil' || isProduct ? 420 : -70
      window.scrollTo(0, target.offsetTop + scrollOffset)

      const sectionEvent = homeSectionEvents[targetId]
      if (sectionEvent) {
        sendGtagEvent(sectionEvent)
      }
    }, 100)
  }, [])

  return (
    <>
      <div className={styles.homepage}>
        <Head>
          <title>{translator.pageTitle}</title>
        </Head>
        <HomeBanner
          leftElement={
            <>
              <div className={`${styles.bannerParagraphContainer}`}>
                <p className={cardStyles.bannerTitle}>{translator.preTitle}</p>
                <p className={cardStyles.bannerTitleBig}>{translator.titleColored}</p>
                <p className={cardStyles.bannerTitle}>{translator.postTitle}</p>
              </div>
              <p
                className={`${cardStyles.bannerDescription} pt-[24px]`}
                dangerouslySetInnerHTML={{ __html: translator.subTitle }}
              />
              <div
                role="button"
                className={`${styles.coloredButton}`}
                onClick={() => {
                  if (typeof window !== undefined) {
                    // @ts-ignore
                    window.gtag('event', 'web_click_getstarted_button')
                    window.location.href = '/sigorta.html?p=bize-ulasin'
                  }
                }}
              >
                <span>{translator.startButton}</span>
              </div>
            </>
          }
          rightElement={
            <div className="xl:w-[521px] md:h-[371px]">
              <img className={`${cardStyles.bannerImage}`} src="/homeBanner.png" alt="sigorta hizmetleri" />
            </div>
          }
          backgroundImage="/homeBackground.png"
        />

        <div className={styles.homepageMainSpace}>
          <div className={`${userStyles.containerSpacing}`}>
            <CardSection
              title={translator.step0.title}
              titleClass={userStyles.bigTitle}
              description={translator.step0.text}
              descriptionClass={userStyles.bigDescription}
            />
          </div>
          <div id="ihtiyac" />
          <div className={`${userStyles.containerTopSpacing} bg-[#F5F5F5]`}>
            <CardSection
              title={translator.step1.title}
              description={translator.step1.text}
              child={
                <img
                  className={`${styles.career__img} sm:max-w-[50%]`}
                  src="/card_img/home_card1_image.png"
                  alt=""
                />
              }
            />
          </div>

          <div id="urun" />
          <div className={`${userStyles.containerSpacing}`}>
            <CardSection
              title={translator.step2.title}
              description={translator.step2.text}
              child={
                <>
                <div className={`${cardStyles.cardSection__area}`}>
                  {cardInfos2?.map((item) => {
                    return item
                  })}
                </div>
                <div className={`${cardStyles.cardSection__area_2}`}>
                  {cardInfosSecondary?.map((item) => {
                    return item
                  })}
                </div>
                  </>
              }
            />
          </div>
          <div id="entegrasyon" />
          <div className={`${userStyles.containerSpacing} bg-[#F5F5F5]`}>
            <CardSection
              title={translator.step3.title}
              description={translator.step3.text}
              child={
                <div className={`${cardStyles.cardSection__area}`}>
                  {cardInfos3?.map((item) => {
                    return item
                  })}
                </div>
              }
            />
          </div>
        </div>

        <div id="partner" />
        <CompanySection title={translator.partners} items={partners} />
        <div id="sigorta" />
        <CompanySection
          bgColor="#F5F5F5"
          title={translator.agreedInsuranceCompanies}
          items={insuranceCompanies}
          />
        <CookiesModal />
      </div>
    </>
  )
}

export default Home
